import React, { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import '../Styles/SalaGallery.css';

const importAll = (r) => {
    return r.keys().map(r);
};

// Auto-load all images from ../Resources/images
const images = importAll(require.context('../Resources/images', false, /\.(png|jpe?g|svg|webp|avif)$/));

const galleryImages = images.map((src, index) => ({
    id: index,
    src: src,
    alt: `Sala Gallery Image ${index + 1}`
}));

const SalaGallery = () => {
    const [currentIndex, setCurrentIndex] = useState(0);

    // Number of items to show at once
    const itemsPerPage = 4;

    useEffect(() => {
        if (galleryImages.length <= itemsPerPage) return;

        const interval = setInterval(() => {
            setCurrentIndex((prevIndex) => (prevIndex + itemsPerPage) % galleryImages.length);
        }, 5000); // Change images every 5 seconds

        return () => clearInterval(interval);
    }, []);

    // Get the current set of images to display
    const visibleImages = [];
    if (galleryImages.length > 0) {
        for (let i = 0; i < itemsPerPage; i++) {
            // Use modulo to wrap around seamlessly if needed
            const index = (currentIndex + i) % galleryImages.length;
            visibleImages.push(galleryImages[index]);
        }
    }

    return (
        <div className="sala-gallery-container" id="gallery">
            <div className="sala-gallery-header">
                <motion.h2
                    initial={{ opacity: 0, y: 30 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.8 }}
                    viewport={{ once: true }}
                >
                    Gallery
                </motion.h2>
            </div>

            <div className="gallery-display-area">
                {[0, 1, 2, 3].map((slotIndex) => {
                    // Calculate which image belongs in this slot
                    const imageIndex = (currentIndex + slotIndex) % galleryImages.length;
                    const image = galleryImages[imageIndex];

                    if (!image) return null; // Safety check

                    return (
                        <div
                            key={slotIndex} // Static key for the container
                            className="gallery-item"
                        >
                            <AnimatePresence>
                                <motion.img
                                    key={`${image.id}`} // Key changes on image update, triggering transition
                                    src={image.src}
                                    alt={image.alt}
                                    className="gallery-image"
                                    initial={{ opacity: 0, scale: 1.1 }}
                                    animate={{ opacity: 1, scale: 1 }}
                                    exit={{ opacity: 0, scale: 1.1 }}
                                    transition={{ duration: 2.5, ease: "easeInOut" }} // Slower crossfade
                                />
                            </AnimatePresence>
                        </div>
                    );
                })}
                {galleryImages.length === 0 && <p style={{ color: 'white' }}>No images found in src/Resources/images</p>}
            </div>
        </div>
    );
};

export default SalaGallery;
